import React from "react";
import { Checkbox, Radio, RadioGroup, Toggle } from "@opendate-app/setlist";
import { useSeriesEditContext } from "../SeriesEditApp";
import StepFooter from "./StepFooter";

const DisplaySection = () => {
  const { form, setField, options, goToStep, setupWizardEnabled, seriesSettingsEnabled, stepBeforeDisplay, settings, setSettings } = useSeriesEditContext();
  const defaults = options.dateListDefaults || {};
  const patchSettings = (changes) => setSettings((current) => ({ ...current, ...changes }));

  return (
    <div className="series-edit-card">
      <h2 className="series-edit-section-title">Display</h2>
      <p className="series-edit-section-subtitle">How dates read on your public series page.</p>

      {seriesSettingsEnabled && (
        <div className="series-display-visibility">
          <span className="series-edit-label series-edit-label-flush" id="series-visibility-label">Who can find it</span>
          <div role="radiogroup" aria-labelledby="series-visibility-label">
            <RadioGroup
              name="series-visibility"
              value={settings.isPublic ? "public" : "private"}
              onChange={(value) => patchSettings({ isPublic: value === "public", ...(value === "private" ? { promoteOnBandsintown: false } : {}) })}
            >
              <Radio id="series-visibility-public" value="public" label="Public" aria-describedby="series-visibility-public-hint" />
              <p className="series-edit-hint" id="series-visibility-public-hint">Listed on your website, widget and Opendate.</p>
              <Radio id="series-visibility-private" value="private" label="Private" aria-describedby="series-visibility-private-hint" />
              <p className="series-edit-hint" id="series-visibility-private-hint">Only people with the link can buy.</p>
            </RadioGroup>
          </div>
          <div className="series-edit-display-option">
            <Toggle
              id="series-promote-on-bandsintown"
              label="Promote on Bandsintown"
              description="List every public date on Bandsintown."
              disabled={!settings.isPublic}
              checked={settings.isPublic && settings.promoteOnBandsintown}
              onChange={(value) => patchSettings({ promoteOnBandsintown: value && value.target ? value.target.checked : Boolean(value) })}
            />
          </div>
        </div>
      )}

      <p className="series-edit-hint">
        {options.seriesSettingsUrl ? (
          <>
            Whether each date shows its end time is set for your whole team in{" "}
            <a href={options.seriesSettingsUrl}>Settings → Series</a>.
          </>
        ) : (
          "Whether each date shows its end time is set for your whole team by an account owner, in Settings → Series."
        )}
      </p>

      <div className="series-edit-display-option">
        <Checkbox
          id="series-show-event-details"
          label="Show each event's title and image"
          checked={form.showEventDetailsOnPublicPage ?? false}
          onChange={(event) => setField("showEventDetailsOnPublicPage", event.target.checked)}
        />
        <p className="series-edit-hint">
          Each date shows its own event's title and image. Use this when the series is a collection of
          different events.
        </p>
      </div>

      <label className="series-edit-label" htmlFor="series-date-list-heading">Date list heading</label>
      <input
        id="series-date-list-heading"
        name="date_list_heading"
        className="series-edit-input"
        placeholder={defaults.heading}
        maxLength={255}
        value={form.dateListHeading || ""}
        onChange={(event) => setField("dateListHeading", event.target.value)}
      />

      <label className="series-edit-label" htmlFor="series-date-list-instructions">Instructions</label>
      <textarea
        id="series-date-list-instructions"
        name="date_list_instructions"
        className="series-edit-input series-edit-textarea"
        placeholder={defaults.instructions}
        maxLength={1000}
        value={form.dateListInstructions || ""}
        onChange={(event) => setField("dateListInstructions", event.target.value)}
      />
      <p className="series-edit-hint">Shown above the list of dates. Leave blank to use the default.</p>

      <label className="series-edit-label" htmlFor="series-ticket-note">Ticket note</label>
      <input
        id="series-ticket-note"
        name="ticket_note"
        className="series-edit-input"
        placeholder={defaults.ticketNote}
        maxLength={255}
        value={form.ticketNote || ""}
        onChange={(event) => setField("ticketNote", event.target.value)}
      />
      <p className="series-edit-hint">Shown in the Event Info box beside the dates. Leave blank to use the default.</p>

      <StepFooter
        onBack={() => goToStep(setupWizardEnabled ? stepBeforeDisplay : "details")}
        onNext={setupWizardEnabled ? () => goToStep("review") : undefined}
      />
    </div>
  );
};

export default DisplaySection;
